

$( document ).ready(function() {

    $(function () {
        $('input[name="lotteries_campaign_password"]').hide();
        $('input[name="lotteries_campaign_confirm_password"]').hide();

        //show it when the checkbox is clicked
        $('input[name="lotteries_create_account_checked"]').on('click', function () {
            if ($(this).prop('checked')) {
                $('input[name="lotteries_campaign_password"]').fadeIn();
                $('input[name="lotteries_campaign_confirm_password"]').fadeIn();
            } else {
                $('input[name="lotteries_campaign_password"]').hide();
                $('input[name="lotteries_campaign_confirm_password"]').hide();
            }
        });
    });

    $("#lotteries_campaign_click").on('click', function(e) {
            e.preventDefault();

            if (typeof grecaptcha !== 'undefined' && grecaptcha.getResponse().length === 0) {
                $('#error-captcha').show();
                return;
            }
            $('#error-captcha').hide();
            var postData = {

                firstName: $("#lotteries_campaign_first_name").val(),
                lastName: $("#lotteries_campaign_last_name").val(),
                email: $("#lotteries_campaign_email").val(),
                campaignId: $("#campaignId").val(),
                phone:$("#lotteries_campaign_phone").val(),
                orders:$("#lotteries_campaign_rds").val(),
                newsletterChecked: $("#lotteries_newsletter_accepted").is(':checked'),
                termsAndConditionsChecked: $("#lotteries_campaign_accepted").is(':checked'),
                myAccountChecked: $("#lotteries_create_account_checked").is(':checked'),
                password: $("#lotteries_campaign_password").val(),
                confirmPassword: $("#lotteries_campaign_confirm_password").val(),
                titleCode: $("input[name=lotteries_campaign_gender]:checked").val()
            };

            var captchaResponse = "noCaptcha";
            if (typeof grecaptcha !== 'undefined'){
                captchaResponse=grecaptcha.getResponse();
            }

            $.ajax({
                'type': 'POST',
                'url': "/campaign/lotteries/submit/" + captchaResponse,
                'contentType': 'application/json',
                'data': JSON.stringify(postData),
                'dataType': 'json',
                success: function(response) {
                  if(response.status == "SUCCESS"){
                       $("#campaign-errors").hide();
                       $("#lotteries_campaign_content").html("<h4 style='color:green'>"+$('#lotteriesSuccessText').val()+"</h4>");
                  }else{
                     var errorInfo = "";
                     for(i =0 ; i < response.result.length ; i++){
                         errorInfo += "<div class='text text-danger'>" + response.result[i]+"</div>";
                     }
                     $('#campaign-errors').html(errorInfo);
                     $("#campaign-errors").show();
                     if (typeof grecaptcha !== 'undefined'){
                        grecaptcha.reset();
                     }
                  }

                },
                error: function(data) {
                   $("#lotteries_campaign_content").html("<h4 style='color:red'>"+$('#lotteriesError').val()+"</h4>");
                }
            });

        });
});

var LotteriesCampaign = (function ($) {
    function submitLotteries(event,form) {
            event.preventDefault();
            if (typeof grecaptcha !== 'undefined' && grecaptcha.getResponse().length == 0) {
                $('#error-captcha').show();
                return;
            }
            $('#error-captcha').hide();
            var postData = {

                firstName: $(".lotteries_campaign_first_name:eq(0)",form).val(),
                lastName: $(".lotteries_campaign_last_name:eq(0)",form).val(),
                email: $(".lotteries_campaign_email:eq(0)",form).val(),
                campaignId: $(".campaignId:eq(0)",form).val(),
                phone:$(".lotteries_campaign_phone:eq(0)",form).val(),
                orders:$(".lotteries_campaign_rds:eq(0)",form).val(),
                termsAndConditionsChecked: $(".lotteries_campaign_accepted:eq(0)",form).is(':checked'),
                newsletterChecked: $(".lotteries_newsletter_accepted:eq(0)",form).is(':checked'),
                password: $(".lotteries_campaign_password:eq(0)",form).val(),
                confirmPassword: $(".lotteries_campaign_confirm_password:eq(0)",form).val()
            };

            var captchaResponse = "noCaptcha";
            if (typeof grecaptcha !== 'undefined'){
                captchaResponse=grecaptcha.getResponse();
            }

            $.ajax({
                'type': 'POST',
                'url': "/campaign/lotteries/submit/" + captchaResponse,
                'contentType': 'application/json',
                'data': JSON.stringify(postData),
                'dataType': 'json',
                success: function(response) {
                  if(response.status == "SUCCESS"){
                       $(".campaign-errors:eq(0)",form).hide();
                       $(".lotteries_campaign_content:eq(0)",form).html("<h4 style='color:green'>"+$('.lotteriesSuccessText:eq(0)',form).val()+"</h4>");

                  }else{
                     errorInfo = "";
                     for(var i =0 ; i < response.result.length ; i++){
                         errorInfo += "<div class='text text-danger'>" + response.result[i]+"</div>";
                     }
                    $('.campaign-errors:eq(0)',form).html(errorInfo);
                     $(".campaign-errors:eq(0)",form).show();
                     if (typeof grecaptcha !== 'undefined'){
                        grecaptcha.reset();
                     }
                  }

                },
                error: function(data) {
                   $(".lotteries_campaign_content:eq(0)",form).html("<h4 style='color:red'>"+$('.lotteriesError:eq(0)',form).val()+"</h4>");
                }
            });
        }

    return {
            submitLotteries: submitLotteries
        }
})(jQuery);
